type IsUrlOptions = {
  /**
   * When enabled, this permits URLs without a protocol (e.g. "https://").
   * Disabled by default.
   */
  lenient?: boolean
}

/**
 * Validates a given string as a URL, with optional protocol leniency.
 */
export const isUrl = (
  str: string,
  { lenient = false }: IsUrlOptions = {}
): boolean => {
  str = str.trim()
  if (str.includes(' ')) {
    return false
  }

  try {
    new URL(str)
    return true
  } catch {
    return lenient ? isUrl(`http://${str}`) : false
  }
}
